var _title, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFullscreenCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "fullscreen-collapse")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.76,17.61a1.36,1.36,0,0,1-1-.4,1.39,1.39,0,0,1,0-2l11.4-11.4a1.38,1.38,0,0,1,2,1.95l-11.4,11.4A1.37,1.37,0,0,1,23.76,17.61Z",
    fill: "#231f20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.89,17.66a1.41,1.41,0,0,1-.68-.18,6.55,6.55,0,0,0-5.8,0A1.38,1.38,0,0,1,23.12,15c.18-.09,4.37-2.26,8.46.07a1.38,1.38,0,0,1-.69,2.57Z",
    fill: "#231f20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.76,17.61a1.37,1.37,0,0,1-1.21-2,6.65,6.65,0,0,0,0-5.81,1.38,1.38,0,1,1,2.39-1.37c2.33,4.09.16,8.28.07,8.46A1.37,1.37,0,0,1,23.76,17.61Z",
    fill: "#231f20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.24,17.61a1.37,1.37,0,0,1-1-.4L3.86,5.81A1.38,1.38,0,0,1,5.81,3.86l11.4,11.4a1.39,1.39,0,0,1,0,2A1.36,1.36,0,0,1,16.24,17.61Z",
    fill: "#231f20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.24,17.61A1.37,1.37,0,0,1,15,16.88c-.09-.18-2.26-4.37.07-8.46a1.38,1.38,0,1,1,2.39,1.37,6.55,6.55,0,0,0,0,5.8,1.37,1.37,0,0,1-1.21,2Z",
    fill: "#231f20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11,17.66a1.38,1.38,0,0,1-.69-2.57c4.09-2.33,8.28-.16,8.46-.07a1.37,1.37,0,0,1,.57,1.86,1.36,1.36,0,0,1-1.85.57,6.65,6.65,0,0,0-5.81,0A1.41,1.41,0,0,1,9.11,17.66Z",
    fill: "#231f20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83,36.54a1.36,1.36,0,0,1-1-.4,1.39,1.39,0,0,1,0-2l11.4-11.4a1.38,1.38,0,0,1,2,1.95L5.81,36.14A1.37,1.37,0,0,1,4.83,36.54Z",
    fill: "#231f20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.55,26a8.23,8.23,0,0,1-4.13-1.08,1.38,1.38,0,0,1,1.37-2.39,6.67,6.67,0,0,0,5.81,0A1.37,1.37,0,0,1,16.88,25,10,10,0,0,1,12.55,26Z",
    fill: "#231f20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.29,32.27a1.39,1.39,0,0,1-1.2-.69c-2.33-4.09-.16-8.28-.07-8.46a1.37,1.37,0,0,1,1.86-.57,1.36,1.36,0,0,1,.57,1.85,6.65,6.65,0,0,0,0,5.81A1.38,1.38,0,0,1,17,32.09,1.41,1.41,0,0,1,16.29,32.27Z",
    fill: "#231f20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.16,36.54a1.36,1.36,0,0,1-1-.4l-11.4-11.4a1.38,1.38,0,0,1,1.95-1.95l11.4,11.4a1.39,1.39,0,0,1,0,2A1.37,1.37,0,0,1,35.16,36.54Z",
    fill: "#231f20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.71,32.27a1.41,1.41,0,0,1-.68-.18,1.38,1.38,0,0,1-.51-1.88,6.67,6.67,0,0,0,0-5.81A1.37,1.37,0,0,1,25,23.12c.09.18,2.26,4.37-.07,8.46A1.39,1.39,0,0,1,23.71,32.27Z",
    fill: "#231f20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.45,26a10,10,0,0,1-4.33-1,1.37,1.37,0,0,1,1.28-2.43,6.65,6.65,0,0,0,5.81,0,1.38,1.38,0,0,1,1.37,2.39A8.23,8.23,0,0,1,27.45,26Z",
    fill: "#231f20"
  })));
}

export default SvgFullscreenCollapse;